export default __webpack_public_path__ + "static/media/Guitar.b182f99e.jpg";